<template>
  <Teleport to="body">
    <base-modal
      class="deal-modal"
      :is-visible="true"
      :modal-name="t('deal-overview')"
      :title="t('deal-overview')"
      @close-modal="onCloseModal"
    >
      <div class="deal-modal__content">
        <base-image
          v-if="card.image?.src"
          :desktop-url="card.image.src"
          :desktop-alt="card.image.alt"
          :custom-params="{ desktop: 715, tablet: 715, mobile: 715, mobileS: 400 }"
          class="deal-modal__image"
        />
        <h3 v-if="card.title" class="deal-modal__title">{{ card.title }}</h3>
        <sc-rich-text
          v-track-rich-text-links="'deal_modal'"
          class="deal-modal__desc"
          tag="div"
          :field="{ value: card.longDescription }"
        />
        <base-button
          v-if="bookingUrl"
          type="link"
          :link="{ href: bookingUrl }"
          :label="t('book-cta-text-long')"
          class="deal-modal__cta"
        />
        <div v-if="accordionItems.length" class="deal-modal__accordion">
          <h3 v-if="card.accordionTitle" class="deal-modal__accordion-title">
            {{ card.accordionTitle }}
          </h3>
          <ul class="deal-modal__accordion-list">
            <accordion-block-item
              v-for="item in accordionItems"
              :key="item.title"
              :fields="{ title: { value: item.title } }"
              :external="true"
              :heading-type="'h4'"
            >
              <sc-rich-text
                v-track-rich-text-links="'deal_modal'"
                tag="div"
                :field="{ value: item.content }"
              />
            </accordion-block-item>
          </ul>
        </div>
      </div>
    </base-modal>
  </Teleport>
</template>

<script setup lang="ts">
import type { DealModalProps } from '../types';
import { inject, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { RichText as ScRichText } from '@sitecore-jss/sitecore-jss-vue';
import BaseModal from '../../../2_elements/BaseModal/BaseModal.vue';
import vTrackRichTextLinks from '../../../../directives/vTrackRichTextLinks';
import BaseImage from '../../../2_elements/BaseImage/BaseImage.vue';
import BaseButton from '../../../2_elements/BaseButton/BaseButton.vue';
import AccordionBlockItem from '../../../AccordionBlock/AccordionBlockItem/AccordionBlockItem.vue';

const { t } = useI18n();

const bookingUrl = inject<string | null>('bookingUrl', null);

const props = defineProps<DealModalProps>();

const accordionItems = computed(() => {
  const items: { title: string; content: string }[] = [];
  if (props.card.firstSectionTitle && props.card.firstSectionDescription)
    items.push({
      title: props.card.firstSectionTitle,
      content: props.card.firstSectionDescription,
    });
  if (props.card.secondSectionTitle && props.card.secondSectionDescription)
    items.push({
      title: props.card.secondSectionTitle,
      content: props.card.secondSectionDescription,
    });
  if (props.card.thirdSectionTitle && props.card.thirdSectionDescription)
    items.push({
      title: props.card.thirdSectionTitle,
      content: props.card.thirdSectionDescription,
    });
  return items;
});

const emit = defineEmits<{
  'close-modal': [];
}>();
const onCloseModal = () => emit('close-modal');
</script>

<style lang="scss">
@import './scss/DealModal.scss';
</style>
